import { jsonInit } from '@shigo-ui/api-client';

import { createShigoApiClient } from '../../../lib/shigo-api-client';
import {
  networkPerformanceNetworkOptionsSchema,
  networkPerformanceResponseSchema,
  type NetworkPerformanceRequest,
} from './model';

interface NetworkPerformanceClientOptions {
  config: {
    apiBaseUrl: string;
    reportingServiceUrl: string;
    networkId: string;
  };
  accessToken: string;
  fetcher?: typeof fetch;
}

const networkPerformancePath = '/api/report/ch/network-overview';

export function createNetworkPerformanceClient({
  config,
  accessToken,
  fetcher,
}: NetworkPerformanceClientOptions) {
  const apiOptions = { networkId: config.networkId };
  const reportingApi = createShigoApiClient(
    { ...apiOptions, apiBaseUrl: config.reportingServiceUrl },
    accessToken,
    fetcher,
  );
  const coreApi = createShigoApiClient(
    { ...apiOptions, apiBaseUrl: config.apiBaseUrl },
    accessToken,
    fetcher,
  );

  return {
    listNetworks: () =>
      coreApi.request({
        path: '/api/admin/networks/list-all',
        schema: networkPerformanceNetworkOptionsSchema,
      }),
    run: (request: NetworkPerformanceRequest, signal?: AbortSignal) =>
      reportingApi.request({
        path: networkPerformancePath,
        schema: networkPerformanceResponseSchema,
        init: { ...jsonInit('POST', request), ...(signal ? { signal } : {}) },
      }),
    exportCsv: (request: NetworkPerformanceRequest) =>
      reportingApi.requestBlob({
        path: `${networkPerformancePath}/csv/export`,
        init: jsonInit('POST', request),
      }),
  };
}
